import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RubberElementContentComponent } from './rubber-element-content/rubber-element-content.component';
import { RubberElementIframeComponent } from './rubber-element-iframe/iframe.component';
import { RubberElementComponent } from './rubber-element.component';


@NgModule({
    exports: [
        RubberElementComponent,
    ],
    imports: [
        CommonModule,
        RubberElementContentComponent,
        RubberElementIframeComponent,
        RubberElementComponent,
    ],
})
export class PcpRubberElementComponentModule {
}
